<label for="exampleFormControlInput1" class="form-label">Status <sup *ngIf="isRequired">*</sup></label>
<select class="form-select" aria-label="Default select example" (change)="onSelectChange($event.target.value)"
  [formControl]="statusFormControl" [ngClass]="{ 'is-invalid':  statusFormControl.errors && statusFormControl.touched}">
  <option selected disabled="true" value="">Select Status</option>
  <option *ngFor="let status of statusList" [value]="status?.code">{{status?.label}}</option>
</select>
<div *ngIf="statusFormControl && statusFormControl.errors && statusFormControl.touched" class="invalid-feedback">
  <div *ngIf="statusFormControl.errors.required">This is mandatory field, Kindly select status</div>
</div>